import { NgModule } from "@angular/core";
import { SkillListComponent } from "@app/view/setup/assignment/skill-list/skill-list.component";
import { ResourceRouteMapComponent } from "@app/view/shared/resource-route-map/resource-route-map.component";
import { SkillEditorComponent } from "@app/view/setup/assignment/skill-editor/skill-editor.component";
import { ExcludedPropertiesDialogComponent } from "@app/view/setup/resourcing/resources/excluded-properties-dialog/excluded-properties-dialog.component";
import { SharedModule } from "@app/view/shared";
import { SetupRouterModule } from "@app/view/setup/setup-router.module";
import { SetupContainerComponent } from "@app/view/setup/setup-container/setup-container.component";
import { SetupHomeComponent } from "@app/view/setup/setup-home/setup-home.component";
import { ZoneCreateComponent } from "@app/view/setup/resourcing/zone/zone-create/zone-create.component";
import { SorCodeListComponent } from "@app/view/setup/codes/sor-code-list/sor-code-list.component";
import { VisitTypeListComponent } from "@app/view/setup/assignment/visit-type-list/visit-type-list.component";
import { SkillDetailComponent } from "@app/view/setup/assignment/skill-detail/skill-detail.component";
import { VisitTypeDetailComponent } from "@app/view/setup/assignment/visit-type-detail/visit-type-detail.component";
import { PriorityListComponent } from "@app/view/setup/codes/priority-list/priority-list.component";
import { PlanningSegmentListComponent } from "@app/view/setup/assignment/planning-segment-list/planning-segment-list.component";
import { SkillProfileListComponent } from "@app/view/setup/assignment/skill-profile-list/skill-profile-list.component";
import { ResourceDetailComponent } from "@app/view/setup/resourcing/resources/resource-detail/resource-detail.component";
import { ResourceListComponent } from "@app/view/setup/resourcing/resources/resource-list/resource-list.component";
import { ResourceEditorComponent } from "@app/view/setup/resourcing/resources/resource-editor/resource-editor.component";
import { SkillProfileDetailComponent } from "@app/view/setup/assignment/skill-profile-detail/skill-profile-detail.component";
import { VisitTypeAddComponent } from "./assignment/visit-type-add/visit-type-add.component";
import { TeamsComponent } from "./resourcing/team/team-list/teams.component";
import { TeamsAddComponent } from "./resourcing/team/teams-add/teams-add.component";
import { TeamDetailComponent } from "./resourcing/team/team-detail/team-detail.component";
import { TeamPlannerAddComponent } from "./resourcing/team/team-planner-add/team-planner-add.component";
import { SkillProfileAddComponent } from "./assignment/skill-profile-add/skill-profile-add.component";
import { SkillRuleAddComponent } from "./assignment/skill-rule-add/skill-rule-add.component";
import { AvailabilityCodeListComponent } from "./codes/availability-code-list/availability-code-list.component";
import { AvailabilityCodeAddComponent } from "./codes/availability-code-add/availability-code-add.component";
import { AvailabilityCodeDetailComponent } from "./codes/availability-code-detail/availability-code-detail.component";
import { WebhookLogComponent } from "./system/webhook-log/webhook-log.component";
import { ApiViewerComponent } from "@app/view/setup/api-viewer/api-viewer.component";
import { VisitTypeSorCodeAddComponent } from "./assignment/visit-type-sor-code-add/visit-type-sor-code-add.component";
import { VisitTypeSkillProfileAddComponent } from "./assignment/visit-type-skill-profile-add/visit-type-skill-profile-add.component";
import { TicketCompletionCodeListComponent } from "./codes/ticket-completion-code-list/ticket-completion-code-list.component";
import { ZoneMapComponent } from "./resourcing/zone/zone-map/zone-map.component";
import { ZoneEditOverlayComponent } from "./resourcing/zone/zone-edit-overlay/zone-edit-overlay.component";
import { SystemAdminHomeComponent } from "./system/system-admin-home/system-admin-home.component";
import { ResourcingHomeComponent } from "./resourcing/resourcing-home/resourcing-home.component";
import { CodesHomeComponent } from "./codes/codes-home/codes-home.component";
import { AssignmentHomeComponent } from "./assignment/assignment-home/assignment-home.component";
import { RosterListComponent } from "@app/view/setup/resourcing/roster/roster-list/roster-list.component";
import { RosterEditComponent } from "@app/view/setup/resourcing/roster/roster-edit/roster-edit.component";
import { DivisionGridComponent } from "@app/view/setup/resourcing/roster/division-grid/division-grid.component";
import { AddDivisionDialogComponent } from "./resourcing/roster/add-division-dialog/add-division-dialog.component";
import { ConfirmDivisionDeleteDialogComponent } from "./resourcing/roster/confirm-division-delete-dialog/confirm-division-delete-dialog.component";
import { NonWorkingDayListComponent } from "./resourcing/roster/non-working-day-list/non-working-day-list.component";
import { AssignmentEditComponent } from "./resourcing/roster/assignment-edit/assignment-edit.component";
import { AssignmentGridComponent } from "./resourcing/roster/assignment-grid/assignment-grid.component";
import { RunHistoryViewGridComponent } from "./resourcing/roster/run-history-view-grid/run-history-view-grid.component";
import { RunHistoryDialogComponent } from "./resourcing/roster/run-history-dialog/run-history-dialog.component";
import { RunHistoryEntryGridComponent } from "./resourcing/roster/run-history-entry-grid/run-history-entry-grid.component";
import { AddAssignmentDialogComponent } from "./resourcing/roster/add-assignment-dialog/add-assignment-dialog.component";
import { RosterRunDialogComponent } from "./resourcing/roster/roster-run-dialog/roster-run-dialog.component";
import { NewZoneConfirmDialogComponent } from "./resourcing/zone/new-zone-confirm-dialog/new-zone-confirm-dialog.component";
import { ZoneDeleteConfirmDialogComponent } from "./resourcing/zone/zone-delete-confirm-dialog/zone-delete-confirm-dialog.component";
import { ShiftEditorComponent } from "./resourcing/roster/shift-editor/shift-editor.component";
import { CyclicalSettingListComponent } from "./assignment/cyclical-setting-list/cyclical-setting-list.component";
import { CyclicalHomeComponent } from "./assignment/cyclical-home/cyclical-home.component";
import { CyclicalHistoryListComponent } from "./assignment/cyclical-history-list/cyclical-history-list.component";
import { CyclicalSegmentEditorComponent } from "./assignment/cyclical-segment-editor/cyclical-segment-editor.component";
import { BookingReasonListComponent } from "./codes/booking-reason-list/booking-reason-list.component";
import { WebhookAdminListComponent } from "./system/webhook-admin-list/webhook-admin-list.component";
import { GroupsComponent } from "./resourcing/groups/groups.component";
import { GroupEditComponent } from "./resourcing/group-edit/group-edit.component";
import { SystemConfigListComponent } from "./system/system-config-list/system-config-list.component";
import { PlannerListComponent } from "./resourcing/planner/planner-list/planner-list.component";
import { PlannerTeamEditorComponent } from "./resourcing/planner/planner-team-editor/planner-team-editor.component";
import { ResourceRuleAddComponent } from "./resourcing/resources/resource-rule-add/resource-rule-add.component";
import { ResourceRuleRenderComponent } from "./resourcing/resources/resource-rule-render/resource-rule-render.component";
import { UrmIntegrationModule } from "@app/integrations/urm/urm-integration.module";
import { PropertyTooltipDirective } from "./resourcing/resources/resource-rule-render/property-tooltip.directive";
import { PropertyTooltipComponent } from "@app/view/setup/resourcing/resources/property-tooltip/property-tooltip.component";
import { TimesheetCodeListComponent } from "./codes/timesheet-code-list/timesheet-code-list.component";
import { AutobookVisitRulesComponent } from "./assignment/autobook-visit-rules/autobook-visit-rules.component";
import { WebhookAuthDialogComponent } from "./system/webhook-auth-dialog/webhook-auth-dialog.component";
import { SkillResourceAddComponent } from "./resourcing/resources/skill-resource-add/skill-resource-add.component";
import { ResourceZoneMappingComponent } from "./resourcing/resources/resource-zone-mapping/resource-zone-mapping.component";
import { ResourceSkillMappingComponent } from "./resourcing/resources/resource-skill-mapping/resource-skill-mapping.component";
import { ResourceRosterAssignmentsComponent } from "./resourcing/resources/roster-assignments/roster-assignments.component";
import { MappingPatternsComponent } from "./resourcing/mapping-patterns/mapping-patterns.component";
import { MappingPatternDetailComponent } from "./resourcing/mapping-patterns/mapping-pattern-detail/mapping-pattern-detail.component";
import { PatternEntrySchedulerComponent } from "./resourcing/mapping-patterns/pattern-entry-scheduler/pattern-entry-scheduler.component";
import { PatternEntryDialogComponent } from "./resourcing/mapping-patterns/pattern-entry-dialog/pattern-entry-dialog.component";
import { ConfirmSkillChangesDialogComponent } from "./resourcing/resources/resource-skill-mapping/confirm-skill-changes-dialog.component";
import { SkillSelectionDialogComponent } from "./resourcing/resources/resource-skill-mapping/skill-selection-dialog.component";
import { ConfirmZoneChangesDialogComponent } from "./resourcing/resources/resource-zone-mapping/confirm-zone-changes-dialog.component";
import { ZoneSelectionDialogComponent } from "./resourcing/resources/resource-zone-mapping/zone-selection-dialog.component";
import { AddResourceAssignmentDialogComponent } from "./resourcing/resources/roster-assignments/add-assignment-dialog/add-assignment-dialog.component";
import { SorCodeOverrideListComponent } from "./codes/sor-code-override-list/sor-code-override-list.component";

@NgModule({
  imports: [
    SharedModule,
    SetupRouterModule,
    UrmIntegrationModule,
    ResourceRouteMapComponent,
    SetupContainerComponent,
    PlanningSegmentListComponent,
    SetupHomeComponent,
    SkillListComponent,
    SkillDetailComponent,
    SkillEditorComponent,
    SkillProfileListComponent,
    SkillProfileDetailComponent,
    SorCodeListComponent,
    PriorityListComponent,
    VisitTypeListComponent,
    VisitTypeDetailComponent,
    ZoneCreateComponent,
    ResourceDetailComponent,
    ResourceListComponent,
    ResourceEditorComponent,
    VisitTypeAddComponent,
    TeamsComponent,
    TeamsAddComponent,
    TeamDetailComponent,
    TeamPlannerAddComponent,
    SkillProfileAddComponent,
    SkillRuleAddComponent,
    AvailabilityCodeListComponent,
    AvailabilityCodeAddComponent,
    AvailabilityCodeDetailComponent,
    WebhookLogComponent,
    ApiViewerComponent,
    VisitTypeSorCodeAddComponent,
    VisitTypeSkillProfileAddComponent,
    TicketCompletionCodeListComponent,
    ZoneMapComponent,
    ZoneEditOverlayComponent,
    SystemAdminHomeComponent,
    ResourcingHomeComponent,
    CodesHomeComponent,
    AssignmentHomeComponent,
    RosterListComponent,
    RosterEditComponent,
    DivisionGridComponent,
    AddDivisionDialogComponent,
    ConfirmDivisionDeleteDialogComponent,
    NonWorkingDayListComponent,
    AssignmentEditComponent,
    AssignmentGridComponent,
    RunHistoryViewGridComponent,
    RunHistoryDialogComponent,
    RunHistoryEntryGridComponent,
    AddAssignmentDialogComponent,
    RosterRunDialogComponent,
    NewZoneConfirmDialogComponent,
    ZoneDeleteConfirmDialogComponent,
    ShiftEditorComponent,
    CyclicalSettingListComponent,
    CyclicalHomeComponent,
    CyclicalHistoryListComponent,
    CyclicalSegmentEditorComponent,
    BookingReasonListComponent,
    WebhookAdminListComponent,
    GroupsComponent,
    GroupEditComponent,
    SystemConfigListComponent,
    PlannerListComponent,
    PlannerTeamEditorComponent,
    ResourceRuleAddComponent,
    ResourceRuleRenderComponent,
    PropertyTooltipDirective,
    PropertyTooltipComponent,
    TimesheetCodeListComponent,
    AutobookVisitRulesComponent,
    WebhookAuthDialogComponent,
    SkillResourceAddComponent,
    ResourceZoneMappingComponent,
    ResourceSkillMappingComponent,
    ResourceRosterAssignmentsComponent,
    ExcludedPropertiesDialogComponent,
    MappingPatternsComponent,
    MappingPatternDetailComponent,
    PatternEntrySchedulerComponent,
    PatternEntryDialogComponent,
    ConfirmSkillChangesDialogComponent,
    SkillSelectionDialogComponent,
    ConfirmZoneChangesDialogComponent,
    ZoneSelectionDialogComponent,
    WebhookLogComponent,
    AddResourceAssignmentDialogComponent,
    SorCodeOverrideListComponent
  ]
})
export class SetupModule {}
